import { CallAPI } from "apiManager/ApiCall";

export const listStudyPlansCall = () =>
  CallAPI({ url: "study-plans", method: "GET" });

export const GetStudyPlanUsageCall = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set("page", String(params.page));
  if (params.limit) qs.set("limit", String(params.limit));
  if (params.search) qs.set("search", params.search);
  const query = qs.toString();
  return CallAPI({ url: `study-plans/admin/usage${query ? `?${query}` : ""}`, method: "GET" });
};

export const getStudyPlanCall = (planId) =>
  CallAPI({ url: `study-plans/${planId}`, method: "GET" });

export const createStudyPlanCall = (body) =>
  CallAPI({ url: "study-plans", method: "POST", body });

export const deleteStudyPlanCall = (planId) =>
  CallAPI({ url: `study-plans/${planId}`, method: "DELETE" });

export const generateStudyLessonCall = (planId, topicId) =>
  CallAPI({
    url: `study-plans/${planId}/topics/${topicId}/lessons`,
    method: "POST",
    body: {},
  });

export const saveLessonProgressCall = (planId, lessonId, body) =>
  CallAPI({
    url: `study-plans/${planId}/lessons/${lessonId}/progress`,
    method: "PUT",
    body,
  });

export const listStudyPodcastsCall = () =>
  CallAPI({ url: "study-plans/podcasts", method: "GET" });

export const requestLessonPodcastCall = (planId, lessonId) =>
  CallAPI({
    url: `study-plans/${planId}/lessons/${lessonId}/podcast`,
    method: "POST",
    body: {},
  });
